'use client';

import { useIntl } from 'react-intl';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { uspsMessages } from './UspsCard.client.messages';
import { AdditionalInfoItem } from '../AdditionalInfoItem/AdditionalInfoItem.client';
import { getValidInfoList } from '../getValidInfoList/getValidInfoList';
import { type RawProductData } from '../../../types';

export type UspsCardProps = {
  uspsData: NonNullable<NonNullable<RawProductData['additionalInfo']>['usps']>;
};

export const UspsCard = ({ uspsData }: UspsCardProps) => {
  const { formatMessage } = useIntl();

  if (uspsData.infoList.length === 0) return null;

  const validInfoList = getValidInfoList(uspsData?.infoList, uspsMessages);

  if (validInfoList.length === 0) return null;

  return (
    <Card>
      <CardHeader hasDivider>
        {formatMessage({
          id: 'uspsCard.cardHeadline',
          defaultMessage: 'Deine Vorteile',
        })}
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-start gap-1 pb-2">
          {validInfoList.map((item) => (
            <AdditionalInfoItem
              key={item.translationKey}
              icon={
                item.iconUrl || <span className="icon-emp-checkmark text-color-text-dark size-4" />
              }
              serviceLayerId={item.serviceLayerId}
              text={formatMessage(item.messageDescriptor, {
                bold: (chunks: React.ReactNode) => <b>{chunks}</b>,
              })}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
